// ABOUTME: Zod validation schemas and TypeScript types for Rusada → TechLog scheduled maintenance item transformation.
import {
  ZRusadaScheduledMaintenanceResponse,
  ZRusadaRegistrationResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogAircraft } from '../../../../types/techLog/aircraft.zod';
import { ZTechlogScheduledMXItemCreateInput } from '../../../../types/techLog/scheduledMXItem.zod';
import { z } from 'zod';

/**
 * Zod schema for a parsed Veryon life value (pre-computed in context provider).
 */
const ZParsedLifeValue = z
  .object({
    value: z.number(),
    unit: z.enum(['FH', 'EH', 'DAYS', 'FL', 'EC']),
    isOverdue: z.boolean(),
  })
  .nullable();

/**
 * Input validation schema for Rusada → TechLog scheduled maintenance item transformation.
 * Uses flat structure per transmormer conventions.
 */
export const ZRusadaToTechlogScheduledMxItemInput = z.object({
  rusada: z.object({
    scheduledMaintenance: ZRusadaScheduledMaintenanceResponse,
    registration: ZRusadaRegistrationResponse,
    parsedNextDue: ZParsedLifeValue, // Pre-computed absolute threshold from nextDue + lifeCode
  }),
  techlog: z.object({
    aircraft: ZTechlogAircraft,
  }),
});

/**
 * Output validation schema for Rusada → TechLog scheduled maintenance item transformation.
 * aircraftId is optional in the canonical schema because legacy callers pass it
 * separately. Required here because it's needed to construct the API request URL.
 */
export const ZRusadaToTechlogScheduledMxItemOutput =
  ZTechlogScheduledMXItemCreateInput.extend({
    aircraftId: z.string(),
  });

// Type exports - inferred from Zod schemas (single source of truth)
export type RusadaToTechlogScheduledMxItemInput = z.infer<
  typeof ZRusadaToTechlogScheduledMxItemInput
>;
export type RusadaToTechlogScheduledMxItemOutput = z.infer<
  typeof ZRusadaToTechlogScheduledMxItemOutput
>;
